<template>
  <div id="authority">
    <el-container style="height: 100%">
      <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
        <el-menu :default-openeds="openList" default-active="0-1">
          <el-submenu index="0">
            <template slot="title"><i class="el-icon-user-solid"></i>用户管理</template>
            <el-menu-item-group>
                <el-menu-item index="0-1" @click="page=0">用户设置</el-menu-item>
                <el-menu-item index="0-2" @click="page=1">创建用户</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="1">
            <template slot="title"><i class="el-icon-s-custom"></i>角色管理</template>
            <el-menu-item-group>
                <el-menu-item index="1-1" @click="page=2">角色查询</el-menu-item>
                <el-menu-item index="1-2" @click="page=3">创建角色</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="2">
            <template slot="title"><i class="el-icon-printer"></i>设备管理</template>
            <el-menu-item-group>
              <el-menu-item index="2-1">设备查询</el-menu-item>
              <el-menu-item index="2-2">设备管理</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="3">
            <template slot="title"><i class="el-icon-collection"></i>项目管理</template>
            <el-menu-item-group>
              <el-menu-item index="3-1">项目查询</el-menu-item>
              <el-menu-item index="3-2">项目管理</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </el-aside>
      <el-main style="padding: 0">
        <div style="height: 100%;width: 100%">
          <user-select v-if="page==0"></user-select>
          <user-create v-if="page==1"></user-create>
          <role-select v-if="page==2"></role-select>
          <role-create v-if="page==3"></role-create>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import RoleSelect from "../../components/authority/roleSelect";
import RoleCreate from "../../components/authority/roleCreate"
import UserSelect from "../../components/authority/userSelect";
import UserCreate from "../../components/authority/userCreate";
export default {
    components: {UserSelect,UserCreate,RoleSelect,RoleCreate},
    data(){
      return{
          page:0,
          openList:['0']
      }
    },
    created() {
        const self = this;
        document.onkeydown = function () {
            const key = window.event.keyCode;
            if (key === 13) {
                // 按Enter键时保持页面序号为3
                self.$store.commit('setPageIndex', 3);
            }
        };
    },
    mounted() {
        // 加载时默认设置页面序号为3
        this.$store.commit('setPageIndex', 3);
    },
};
</script>

<style scoped>
  #authority{
    width: 100%;
    height: 100%;
  }
  #title{
    height: 50px;
    background-color: #5BA0EC;
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// src/views/authority/index.vue